import { IJournalHighlightsItem } from '../../types/journal';
import { IApplicationState } from '../../types/redux';

export function selectJournalHighlights(state: IApplicationState): IJournalHighlightsItem[] | null {
  return state.journalHighlights;
}
